export default __webpack_public_path__ + "static/media/img_15.5ca8e716.webp";